import AccountApi from './AccountApi'
import BrandApi from '@/api/BrandApi';
import DeviceApi from '@/api/DeviceApi'
import DeviceCommandApi from '@/api/DeviceCommandApi'
import DeviceEventApi from '@/api/DeviceEventApi'
import DeviceEventSharedApi from '@/api/DeviceEventSharedApi'
import DictionaryApi from '@/api/DictionaryApi'
import DriversApi from '@/api/DriversApi'
import FleetApi from './FleetApi'
import FleetSettingsApi from '@/api/FleetSettingsApi'
import HereMapsApi from '@/api/HereMapsApi'
import JourneyApi from '@/api/JourneyApi'
import MediaRequestApi from '@/api/MediaRequestApi'
import OrganizationApi from '@/api/OrganizationApi'
import ReportsApi from '@/api/ReportsApi'
import RolesApi from '@/api/RolesApi'
import StatisticsApi from '@/api/StatisticsApi'
import StreamingApi from '@/api/StreamingApi'
import TelemetryApi from '@/api/TelemetryApi'
import TrackingApi from '@/api/TrackingApi'
import UserApi from '@/api/UserApi'
import VehicleApi from '@/api/VehicleApi'
import TreeApi from '@/api/TreeApi'
import TreeVehiclesApi from '@/api/TreeVehiclesApi'

export {
    AccountApi,
    BrandApi,
    DeviceApi,
    DeviceCommandApi,
    DeviceEventApi,
    DeviceEventSharedApi,
    DictionaryApi,
    DriversApi,
    FleetApi,
    FleetSettingsApi,
    HereMapsApi,
    JourneyApi,
    MediaRequestApi,
    OrganizationApi,
    ReportsApi,
    RolesApi,
    StatisticsApi,
    StreamingApi,
    TelemetryApi,
    TrackingApi,
    UserApi,
    VehicleApi,
    TreeApi,
    TreeVehiclesApi
}

const apis = {
    accountApi: new AccountApi(),
    brandApi: new BrandApi(),
    deviceApi: new DeviceApi(),
    deviceCommandApi: new DeviceCommandApi(),
    deviceEventApi: new DeviceEventApi(),
    deviceEventSharedApi: new DeviceEventSharedApi(),
    dictionaryApi: new DictionaryApi(),
    driversApi: new DriversApi(),
    fleetApi: new FleetApi(),
    fleetSettingsApi: new FleetSettingsApi(),
    hereMapsApi: new HereMapsApi(),
    journeyApi: new JourneyApi(),
    mediaRequestApi: new MediaRequestApi(),
    organizationApi: new OrganizationApi(),
    reportsApi: new ReportsApi(),
    rolesApi: new RolesApi(),
    statisticsApi: new StatisticsApi(),
    streamingApi: new StreamingApi(),
    telemetryApi: new TelemetryApi(),
    trackingApi: new TrackingApi(),
    userApi: new UserApi(),
    vehicleApi: new VehicleApi(),
    treeApi: new TreeApi(),
    treeVehicleApi: new TreeVehiclesApi()
}

export default apis
